/* COUNTDOWN */

interface AudioES {
  file: string;
  classCss?: string;
  volume?: number;
  loop?: boolean;
  preload?: any;
  play?: boolean;
  append?: boolean;
  dataAtr?: { name: string; value: string };
}

interface CountdownRef {
  mainContainer: HTMLElement;
  countdownText: HTMLElement;
  countdownProgress: HTMLElement;
  countdownProgress2: HTMLElement;
}

declare global {
  interface Window {
    dama: any;
    datalayer: any;
    SHA256: any;
    drupalSettings: any;
  }
}

const pathMedia = `/modules/custom/co_trivia_150`

// ---------------- COUNTDOWN MODULE ----------------
export const Countdown = (function () {
  let countdownClass: string = "count";
  let changedVelocity: boolean = false;
  let counter = setInterval(() => 100);

  let callFunc: () => void;
  let hasCallFunc: boolean = false;

  let seconds: number = 15;
  let totalTime: number = seconds * 100;
  let startTime: number;
  let usedTime: number = 0;

  let referencesHTML: CountdownRef = {
    mainContainer: document.querySelector(`.${countdownClass}`),
    countdownText: document.querySelector(`.${countdownClass} .${countdownClass}__text`),
    countdownProgress: document.querySelector(`.${countdownClass} .${countdownClass}__progress`),

    // SECOND PROGRESS
    countdownProgress2: document.querySelector(`.${countdownClass} .${countdownClass}__progress-sec`)
  };

  // ----------------- CAST FUNCTIONS -----------------
  // El tiempo general esta en centisegundos
  // por eso se opera con 100 y no con 1000
  function _calculateTime(mSecs: number): string {
    let mi = Math.floor(mSecs / 100 / 60);
    let ss = Math.floor((mSecs / 100) % 60);
    let ms = Math.floor(mSecs % 100);

    const fillZero = (time: number): string => {
      return time < 10 ? `0${time}` : `${time}`;
    };

    return `${fillZero(mi)}:${fillZero(ss)}:${fillZero(ms)}`;
  }

  function _calculatePercentage(nwTime: number): number {
    return (nwTime * 100) / totalTime;
  }

  function calculateMs(time: string) {
    let [mi, ss, ms] = time.split(":");
    let total = parseInt(mi) * 60 * 100 + parseInt(ss) * 100 + parseInt(ms);
    return total;
  }

  // ----------------- AUDIO FUNCTIONS -----------------

  function _setAudio(actionType: string = "create") {
    let { mainContainer, countdownText } = referencesHTML;
    let audioTag: HTMLAudioElement = mainContainer.querySelector(
      `.${countdownClass}__audio`
    );

    const createAudio = (refAudio: AudioES, source?: boolean) => {
      let { file, classCss, loop, preload, dataAtr, play, append } = refAudio;

      let nwAudioTag = document.createElement("audio");

      if (source) {
        let nwSource = document.createElement("source");
        nwSource.src = `${pathMedia}/sources/dist/audio/${file}`;
        nwSource.type = "audio/mpeg";
        nwAudioTag.append(nwSource);
      } else {
        nwAudioTag.src = `${pathMedia}/sources/dist/audio/${file}`;
      }

      nwAudioTag.classList.add(classCss);
      nwAudioTag.loop = loop || false;
      nwAudioTag.preload = preload || "auto";
      if (dataAtr) nwAudioTag.setAttribute(dataAtr.name, dataAtr.value);
      if (play) nwAudioTag.play();
      if (append) mainContainer.append(nwAudioTag);
    };
    switch (actionType) {
      case "create":
        let clock: AudioES = {
          file: "countdown.mp3",
          loop: true,
          preload: "metadata",
          append: true,
          play: window.statusPermits,
          classCss: `${countdownClass}__audio`,
          dataAtr: { name: "data-audio-src", value: "bg_counter" },
        };
        createAudio(clock, true);
        break;

      case "stop":
        audioTag.pause();
        audioTag.currentTime = 0;

        countdownText.classList.remove(`${countdownClass}__text--blink`);
        break;
      case "stopPermits":
        audioTag.pause();
        break;
      case "playPermits":
        audioTag.play();
        break;
      case "velocity":
        countdownText.classList.add(`${countdownClass}__text--blink`);
        break;
    }
  }

  // ----------------- TIMER FUNCTIONS -----------------

  function _startTimer(): void {
    _setAudio();
    startTime = +new Date();

    counter = setInterval(() => {
      usedTime = Math.floor((+new Date() - startTime) / 10);
      var nwTime = totalTime - usedTime;

      let timeString: string = _calculateTime(nwTime);
      let percentage = _calculatePercentage(nwTime);

      // Updated output
      referencesHTML.countdownText.textContent = timeString;
      referencesHTML.countdownProgress.setAttribute("value", `${percentage}`);
      referencesHTML.countdownProgress2 && referencesHTML.countdownProgress2.setAttribute("value", `${percentage}`);


      if (nwTime <= 500 && !changedVelocity) {
        changedVelocity = true;
        _setAudio("velocity");
      }
      if (nwTime <= 0) stopTimer(true);
    }, 30);
  }

  function stopTimer(timeEnded?: boolean): string {
    let { countdownText, countdownProgress, countdownProgress2 } = referencesHTML;

    clearInterval(counter);
    _setAudio("stop");

    // TIEMPO USADO
    let totalTimeUsed = countdownText.innerHTML.includes("-")
      ? "00:00:00"
      : countdownText.innerHTML;

    // Reset Variables
    startTime = +new Date();
    usedTime = 0;

    // Updated output
    countdownText.innerHTML = "00:00:00";
    countdownProgress.setAttribute("value", "0");
    countdownProgress2 && countdownProgress2.setAttribute("value", "0");

    const onEnded = new CustomEvent("triviaEnded");
    document.dispatchEvent(onEnded);

    if (timeEnded && hasCallFunc) callFunc();

    return totalTimeUsed;
  }

  function hideCounter(): void {
    referencesHTML.mainContainer.classList.add("hidden");
  }

  function init(nwSeconds?: number): void {
    let timeString: string = _calculateTime(totalTime);
    referencesHTML.countdownText.textContent = timeString;

    if (seconds) {
      seconds = nwSeconds;
      totalTime = nwSeconds * 100;
    }

    _startTimer();
  }

  function setCallFunc(nwFunc: () => void) {
    callFunc = nwFunc;
    hasCallFunc = true;
  }

  return { init, stopTimer, hideCounter, calculateMs, setCallFunc, _setAudio };
})();
